export default "__VITE_ASSET__DTqyN1yv__"